import React from "react";
import _ from "lodash";
import Cassette from "./Cassette";

function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export default props => {
  const { answered, clickOnAnswer, image } = props;
  // if (currentIndex === 5) return <div>
  //   Gratulacje, Twój wynik to {points}/5
  // </div>

  // const shuffledList = _.clone(answersList[currentIndex])
  // shuffle(shuffledList)

  // const answers = answersList;
  // const imageKey = imagesKeys[currentIndex];
  // const imageValue = imagesValues[currentIndex];
  // const answerKey = answered;
  // const answerValue = answers[answered];

  return (
    <div>
      <div className="column" style={{ float: "right", width: 350 }}>
        <h1 style={{ color: "white" }} className="subtitle">
          {image.title}
        </h1>
        <div
          className="button is-fullwidth"
          style={
            answered === false
              ? { color: "black", background: "white" }
              : { background: "transparent", color: "white" }
          }
          onClick={() => clickOnAnswer(false)}
        >
          Cały obraz
        </div>
        &nbsp;
        {image.variants.map((el, ind) => (
          <span>
            <div
              className="button is-fullwidth"
              style={
                answered === ind + 1
                  ? { color: "black", background: "white" }
                  : { background: "transparent", color: "white" }
              }
              onClick={() => clickOnAnswer(ind + 1)}
            >
              {el.nazwa}
            </div>
            &nbsp;
          </span>
        ))}
      </div>
      {answered ? (
        <div
          style={{
            float: "left",
            width: 400,
            height: 540,
            position: "relative"
          }}
        >
          <div
            className="flip-container"
            onTouchStart="this.classList.toggle('hover');"
            style={{ border: "", width: 400, height: 540 }}
          >
            <div style={{ width: 400, height: 540 }} className="flipper">
              <div style={{ width: 400, height: 540 }} className="front">
                <img
                  style={{ width: 400, height: 540 }}
                  src={
                    Number.isInteger(image.variants[answered - 1].obraz)
                      ? `https://wordpresser.prod.krzysztofsikorski.pl/?domain=arteco-wp.prod.krzysztofsikorski.pl&id=` +
                        image.variants[answered - 1].obraz
                      : image.variants[answered - 1].obraz.url
                  }
                />
              </div>
              <div
                className="back"
                style={{ position: "relative", width: 400, height: 540 }}
              >
                <img
                  style={{ width: 400, height: 540 }}
                  src={
                    Number.isInteger(image.variants[answered - 1].tyl)
                      ? `https://wordpresser.prod.krzysztofsikorski.pl/?domain=arteco-wp.prod.krzysztofsikorski.pl&id=` +
                        image.variants[answered - 1].tyl
                      : image.variants[answered - 1].tyl.url
                  }
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            overflow: "hidden",
            marginRight: 350
          }}
        >
          <div className="image_presentation">
            <img style={{ width: 400, height: 540 }} src={image.front.url} />
          </div>
        </div>
      )}
    </div>
  );

  // return <div className="columns">
  // <div className="column">
  //   <div className="image_presentation">
  //     <img src={'/dane/' + imagesList[currentIndex] + '/' + imagesList[currentIndex] + '-standard.jpg'}/>
  //     <img className="sketch" src={'/dane/' + imagesList[currentIndex] + '/' + imagesList[currentIndex] + '-sketch.png'}/>
  //   </div>
  // </div>
  // <div className="column">
  //   <div className="image_presentation">
  //     <img src={'/dane/' + imagesList[currentIndex] + '/' + imagesList[currentIndex] + '-original.jpg'}/>
  //     <img className="sketch" src={'/dane/' + imagesList[currentIndex] + '/' + imagesList[currentIndex] + '-sketch.png'}/>
  //   </div>
  //   </div>
  // </div>
};

// <div className="column">
// <h3 className="subtitle" style={{marginBottom: 0}}>Posłuchaj wyjaśnienia!</h3>
// <div style={{width:200, marginMop: -30, marginBottom: -30}}>
//   <Cassette src={'/dane/' + imagesList[currentIndex] + '/' + imagesList[currentIndex] + '.mp3'} />
// </div>
// <div className="button is-rounded" onClick={goNext}>Przejdź dalej</div>
// </div>



// WEBPACK FOOTER //
// ./src/Image.js